<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {};
  },
};
</script>

<style lang="less">
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
::-webkit-scrollbar-track {
  background-color: #01c3cc;
  border-radius: 5px;
}
::-webkit-scrollbar-thumb {
  background-color: rgb(157, 244, 247);
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue